import $ from 'jquery'
import Component from  "../models/Component"

export default class Gmultimap extends Component {
    static _initializers = []

    constructor(element, context) {
        super(element, context)

        this.markers = [];

        this.mapStyle = [
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "color": "#878787"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f9f5ed"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#aee0f4"
                    }
                ]
            }
        ]

        Gmultimap._initializers.push(() => {
            this.initGoogleMaps()
        })

        $(() => {
            this.makers = this.getData('markers');
            this.loadGoogleMaps()
        })
    }

    initGoogleMaps() {
        // crea un'istanza della mappa di Google Maps
        this.map = new google.maps.Map(this.element.get(0), {
            zoom: 1,
            minZoom: 3,
            center: {
                lat: 45.12345,
                lng: 9.12345
            },
            scrollwheel: false,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            rotateControl: false,
            styles: this.mapStyle,
        })

        // aggiungi i markers alla mappa
        this.addMarkers(this.makers)

        this.element.parent().removeClass('loading')
    }

    addMarkers(markers) {
        markers.forEach((marker) => {
            const position = {
                lat: marker.lat,
                lng: marker.lng
            };

            const googleMarker = new google.maps.Marker({
                position: position,
                map: this.map,
                url: marker.url,
                icon: {
									url: window.location.origin + '/wp-content/uploads/2024/12/pin-maps.png',
									scaledSize: new google.maps.Size(30, 38),
								} 
            });

            const infoWindowContent = '<div class="popup-marker"><h3>' + marker.title + '</h3><p>' + marker.description + '</p></div>';

            const infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });

            googleMarker.addListener('click', () => {
                infoWindow.open(this.map, googleMarker);
            });

            this.markers.push(googleMarker);
        });
    }

    onMarkerClick(url) {
        window.open(url, '_blank')
    }

    loadGoogleMaps() {
        // aggiungi lo script di Google Maps API se non è già presente
        if (!window.initGoogleMaps) {
            window.initGoogleMaps = () => {
                Gmultimap.initAllGoogleMaps()
            }
            const scriptSrc = 'https://maps.googleapis.com/maps/api/js?key=' + window._gTheme_.google_maps_api_key + '&callback=initGoogleMaps'
            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = scriptSrc
            document.body.appendChild(script)
        }
    }

    static initAllGoogleMaps() {
        Gmultimap._initializers.forEach(function (initializer) {
            initializer()
        })
    }
}
